const SEO = [
	{
		page: "home",
		description:
			"Full-Stack Software Engineer with 4+ years of experience building AI-powered web applications. Specialized in React, Next.js, Node.js, Python, and RAG systems. Expert in LLM integration, system design, and cloud deployments.",
		keywords: ["Yasar Arafath", "Yasar Arafath Ali", "Full-Stack Engineer", "AI Engineer", "RAG Systems", "React Developer", "Next.js Developer", "LLM Integration", "Software Engineer Portfolio", "Full-Stack Software Engineer Portfolio", "full stack engineer", "full stack developer", "full stack engineer portfolio", "full stack developer portfolio"],
	},

	{
		page: "about",
		description:
			"Full-Stack Software Engineer building AI-enabled systems that solve real problems. Led development of production systems serving thousands of users, from hospital management platforms to AI-powered document chat applications.",
		keywords: ["Yasar Arafath", "Yasar Arafath Ali", "Full-Stack Engineer", "AI Engineer", "Software Engineer", "About Yasar Arafath"],
	},

	{
		page: "articles",
		description:
			"Chronological collection of my long-form thoughts on programming, AI/ML, system design, and software engineering best practices.",
		keywords: ["Yasar Arafath", "Yasar Arafath Ali", "Software Engineering Articles", "Tech Blog", "Programming Articles"],
	},

	{
		page: "projects",
		description:
			"AI-powered projects including RAG-based document chat systems, real-time Bitcoin dashboards, and full-stack social media applications. Built with React, Next.js, Node.js, and AI/ML technologies.",
		keywords: ["Yasar Arafath", "Yasar Arafath Ali", "AI Projects", "RAG Systems", "React Projects", "Full-Stack Projects", "Portfolio Projects"],
	},

	{
		page: "contact",
		description:
			"Interested in collaborating on AI-powered projects or discussing opportunities? Get in touch with Yasar Arafath, Full-Stack Software Engineer specializing in AI-enabled web applications.",
		keywords: ["Yasar Arafath", "Yasar Arafath Ali", "Contact", "Software Engineer Contact"],
	},
];

export default SEO;
